import { getSession } from 'next-auth/react';

/**
 * Client-only: use inside event handlers / hooks in components with "use client".
 */
export async function getClientSessionOrThrow(): Promise<{
  accessToken: string;
  userId: string;
}> {
  const session = await getSession();
  if (!session?.accessToken || session.user?.id == null) {
    throw new Error('Unauthorized');
  }
  return {
    accessToken: session.accessToken,
    userId: String(session.user.id),
  };
}

export async function getClientAuthHeader(): Promise<Record<string, string> | undefined> {
  const session = await getSession();
  if (!session?.accessToken) {
    return undefined;
  }
  return { Authorization: `Bearer ${session.accessToken}` };
}
